import { render, staticRenderFns } from "./Comp18t3.vue?vue&type=template&id=0588a4b5&scoped=true&"
import script from "./Comp18t3.vue?vue&type=script&lang=js&"
export * from "./Comp18t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp18t3.vue?vue&type=style&index=0&id=0588a4b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0588a4b5",
  null
  
)

export default component.exports